import {Editor} from "@tiptap/core";
import ICONS from "../../assets/ICONS";
import {Transaction} from "prosemirror-state";
import {DceJsx} from "dce-jsx";
import {ToolbarItem} from "../ToolbarItem";

export default class YouTubeButton extends ToolbarItem {

    private editor:Editor;

    private options: HTMLElement;

    private optionsUrl: HTMLInputElement;
    private optionsW: HTMLInputElement;
    private optionsH: HTMLInputElement;

    private optionsBtnAccept: HTMLButtonElement;

    constructor() {
        super();
    }

    mount(editor: Editor): void {
        this.editor = editor;
    }

    public click(e: any): void {
        if(this.options.contains(e.target as HTMLElement)){

        }else{

            if(!this.root.classList.contains('disabled')) {
                if(!this.root.classList.contains('opened')) {
                    this.preOpen();
                    this.root.classList.add('opened');
                }else{
                    this.root.classList.remove('opened');
                }
            }

        }

    }

    public preOpen(){

        let active = this.editor.isActive('youtube');

        console.log(active);

        // let active = this.editor.isActive('link');
        //
        if(active){
            let a = this.editor.getAttributes('youtube');
            this.optionsUrl.value = a.src;
            this.optionsH.value = a.height;
            this.optionsW.value = a.width;
            console.log("YOUTUBE:", a);
        }else{
            this.optionsUrl.value = '';
            this.optionsH.value = '360';
            this.optionsW.value = '640';
        }
    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{
        if(this.isActive(editor)){
            this.root.classList.add('active');
        }else{
            this.root.classList.remove('active');
        }

        if(this.root.classList.contains('opened')){
            this.root.classList.remove('opened');
        }
    }

    public setLink(): void {

        let url = this.optionsUrl.value;

        this.editor.commands.setYoutubeVideo({
            src: url,
            width: Math.max(320,parseInt(this.optionsW.value, 10)) || 640,
            height: Math.max(180, parseInt(this.optionsH.value, 10)) || 360
        });

    }

    public removeLink(): void {

        if(this.editor.isActive('link')){
            (this.editor.chain().focus().extendMarkRange('link') as any).unsetLink().run()
        }

    }

    public isActive(editor:Editor): boolean {
        return false; //this.editor.isActive('link');
    }


    bindByRef(ref: string, elem: HTMLElement) {
        if(ref == 'options'){
            this.options = elem;
        }

        switch (ref){
            case 'o-url':
                this.optionsUrl = elem as HTMLInputElement;
                break;

            case 'o-width':
                this.optionsW = elem as HTMLInputElement;
                break;

            case 'o-height':
                this.optionsH = elem as HTMLInputElement;
                break;

            case 'o-btn-accept':
                this.optionsBtnAccept = elem as HTMLButtonElement;
                break;


        }

    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={(e) => this.click(e)} className={"btn dropdown"}>
                <i ref={"current-icon"} dangerouslySetInnerHTML={{__html: ICONS.youtube}}></i>

                <div className={"options link-options"} ref={"options"}>
                    <input type={"text"} ref={"o-url"} placeholder={"Adres filmu youtube"}/>

                    <div className={"link-options--row"}>
                        <div className={"link-options--row-lbl"}>Rozmiar</div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                    <input type={"text"} ref={"o-width"} placeholder={"Szerokość"} value={"640"} style={{maxWidth: '50px', marginRight: '10px'}}/>
                        <div style={{marginBottom: '8px'}}>X</div>
                    <input type={"text"} ref={"o-height"} placeholder={"Wysokość"} value={"360"} style={{maxWidth: '50px', marginLeft: '10px'}}/>
                    </div>

                    <button type="button" ref={"o-btn-accept"} onClick={() => this.setLink()} className={"gray"}>Wstaw film</button>
                </div>
            </button>
        );
    }
}